import {
  SET_WAREHOUSE_CHECK_CAMPAIGN_NAMES,
  CHECK_NAMES_WH_LOADER,
  SET_WAREHOUSE_CABINET_LIMITS,
  WAREHOUSE_CABINET_LIMITS_LOADER,
  SET_WAREHOUSE_CABINET_LIMITS_TOTAL
} from "./actionTypes";

const INIT_STATE = {
  campaignNamesData: {
    next: null,
    previous: null,
    page: 1,
    results: [],
  },
  whNamesLoader: false,
  loading: false,
  cabinetLimitsData: {
    next: null,
    previous: null,
    page: 1,
    results: [],
  },
  cabinetLimitsLoading: false,
  cabinetLimitsTotal: {
    total_limit: 0,
    total_difference: 0,
  },
  isError: false,
};

const Warehouse = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_WAREHOUSE_CHECK_CAMPAIGN_NAMES:
      return {
        ...state,
        campaignNamesData: action.payload,
      };
    case CHECK_NAMES_WH_LOADER:
      return {
        ...state,
        whNamesLoader: !state.whNamesLoader,
      }
    case SET_WAREHOUSE_CABINET_LIMITS_TOTAL:
      return {
        ...state,
        cabinetLimitsTotal: action.payload,
      }
    case SET_WAREHOUSE_CABINET_LIMITS:
      return {
        ...state,
        cabinetLimitsData: action.payload,
      }
    case WAREHOUSE_CABINET_LIMITS_LOADER:
      return {
        ...state,
        cabinetLimitsLoading: !state.cabinetLimitsLoading,
      }
    default:
      return state;
  }
};

export default Warehouse;
